import { SVGProps, Ref, forwardRef } from 'react';

export const QrCodeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M3.91 10.791a1.3 1.3 0 1 1-.001 2.6 1.3 1.3 0 0 1 0-2.6" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.91 8.682c2.982 0 3.408.426 3.408 3.409S6.892 15.5 3.91 15.5.5 15.074.5 12.09c0-2.982.426-3.408 3.41-3.408m0 1.4c-.736 0-1.21.028-1.533.089-.187.035-.27.072-.3.088-.016.029-.053.113-.088.3-.06.322-.089.797-.089 1.532s.029 1.21.09 1.532c.035.187.071.27.087.3.03.016.113.053.3.088.322.06.797.089 1.532.089s1.21-.028 1.532-.09c.187-.034.271-.071.3-.087.016-.03.053-.113.088-.3.06-.322.089-.797.089-1.532s-.028-1.21-.089-1.532a1 1 0 0 0-.088-.3 1 1 0 0 0-.3-.088c-.322-.06-.797-.089-1.532-.089m1.842 3.833-.003.003.005-.004z"
                    fill="currentColor"
                />
                <path
                    d="m10.09 12.991.113.005a1.1 1.1 0 0 1 .987 1.095l-.005.112a1.1 1.1 0 0 1-.982.982l-.112.005a1.1 1.1 0 0 1-1.095-.987l-.005-.112a1.1 1.1 0 0 1 1.1-1.1"
                    fill="currentColor"
                />
                <path
                    d="m14.09 12.991.113.005a1.1 1.1 0 0 1 .987 1.095l-.005.112a1.1 1.1 0 0 1-.982.982l-.112.005a1.1 1.1 0 0 1-1.095-.987l-.005-.112a1.1 1.1 0 0 1 1.1-1.1"
                    fill="currentColor"
                />
                <path
                    d="m12.09 10.991.113.005a1.1 1.1 0 0 1 .987 1.095l-.005.112a1.1 1.1 0 0 1-.982.982l-.112.005a1.1 1.1 0 0 1-1.095-.987l-.005-.112a1.1 1.1 0 0 1 1.1-1.1"
                    fill="currentColor"
                />
                <path
                    d="m10.09 8.991.113.005a1.1 1.1 0 0 1 .987 1.095l-.005.112a1.1 1.1 0 0 1-.982.982l-.112.005a1.1 1.1 0 0 1-1.095-.987l-.005-.112a1.1 1.1 0 0 1 1.1-1.1"
                    fill="currentColor"
                />
                <path
                    d="m14.09 8.991.113.005a1.1 1.1 0 0 1 .987 1.095l-.005.112a1.1 1.1 0 0 1-.982.982l-.112.005a1.1 1.1 0 0 1-1.095-.987l-.005-.112a1.1 1.1 0 0 1 1.1-1.1"
                    fill="currentColor"
                />
                <path d="M3.91 2.61a1.3 1.3 0 1 1 0 2.599 1.3 1.3 0 0 1 0-2.6" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.91.5c2.982 0 3.408.426 3.408 3.41 0 2.982-.426 3.408-3.409 3.408S.5 6.892.5 3.91.926.5 3.91.5m0 1.4c-.736 0-1.21.029-1.533.09-.187.035-.27.071-.3.087-.016.03-.052.113-.088.3-.06.322-.089.797-.089 1.532s.029 1.21.09 1.532c.034.187.071.271.087.3.03.016.113.053.3.088.322.06.797.089 1.532.089s1.21-.028 1.532-.089c.187-.035.271-.072.3-.088.016-.029.053-.113.088-.3.06-.322.089-.797.089-1.532S5.89 2.7 5.829 2.377a1 1 0 0 0-.088-.3 1 1 0 0 0-.3-.088C5.12 1.93 4.644 1.9 3.91 1.9"
                    fill="currentColor"
                />
                <path d="M12.09 2.61a1.3 1.3 0 1 1 .001 2.599 1.3 1.3 0 0 1 0-2.6" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.09.5c2.984 0 3.41.426 3.41 3.41 0 2.982-.426 3.408-3.41 3.408-2.982 0-3.408-.426-3.408-3.409S9.108.5 12.09.5m0 1.4c-.734 0-1.21.029-1.531.09-.187.034-.271.071-.3.087-.016.03-.053.113-.088.3-.06.322-.089.797-.089 1.532s.028 1.21.089 1.532c.035.187.072.271.088.3.029.016.113.053.3.088.322.06.797.089 1.532.089s1.21-.028 1.532-.089c.187-.035.27-.072.3-.088.016-.029.053-.113.088-.3.06-.322.089-.797.089-1.532s-.028-1.21-.09-1.532a1 1 0 0 0-.087-.3 1 1 0 0 0-.3-.088c-.322-.06-.797-.089-1.532-.089"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
QrCodeOutlinedSize16Glyph.displayName = 'QrCodeOutlinedSize16Glyph';
